import './components/calculators/format';
import './components/calculators/finance';
import './components/calculators/calculator-products';
import './components/calculators/mortgage';
import './components/calculators/input';
import './components/calculators/products';

// =====================================================================
//  BUSINESS LOAN — interactivity layer
//  Static markup lives in page-calculator-business-loan.php.
// =====================================================================
(function () {
  const fmt = Calc.format;
  const fin = Calc.finance;

  const REF_AMOUNTS = [50000, 100000, 200000, 300000, 500000, 750000, 1000000];
  const REF_TENURES = [1, 3, 5, 7, 10];

  const state = {
    amount: 100000,
    interestRate: 0.075,  // decimal
    tenure: 5,            // years
    activeTab: 'breakdown',
    sort: { key: 'best', dir: 'asc' },    // template's selected option sets the default
  };

  const setText = (id, val) => { const el = document.getElementById(id); if (el) el.textContent = val; };
  const setVal = (sel, val) => { const el = document.querySelector(sel); if (el) el.textContent = val; };
  const syncInput = (id, val) => Calc.input.syncValue(id, val);
  const esc = (s) => String(s).replace(/[&<>"']/g, (c) => (
    { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]
  ));

  function computeCalc() {
    return fin.reducingRate(state.amount, state.interestRate, state.tenure);
  }

  function updateStatBand() {
    const calc = computeCalc();
    setText('bl-stat-monthly',  fmt.money(calc.monthlyInstalment, 0));
    setText('bl-stat-rate',     fmt.percent(state.interestRate));
    setText('bl-stat-interest', fmt.money(calc.totalInterest, 0));
    setText('bl-stat-total',    fmt.money(calc.totalRepayment, 0));
  }

  function updateBreakdown() {
    const calc = computeCalc();
    setText('bl-r-amount',   fmt.money(state.amount));
    setVal('.bl-r-tenure-y', state.tenure);
    setVal('.bl-r-tenure-m', state.tenure * 12);
    setVal('.bl-r-rate-num', fmt.percent(state.interestRate));
    setText('bl-r-interest', fmt.money(calc.totalInterest));
    setText('bl-r-total',    fmt.money(calc.totalRepayment));
    setText('bl-r-monthly',  fmt.money(calc.monthlyInstalment));
  }

  function updateAmortization() {
    const host = document.getElementById('bl-amort');
    if (!host) return;
    Calc.amortView.renderInline(host, {
      startExpanded: true,
      amount: state.amount,
      rate: state.interestRate,
      years: state.tenure,
      method: 'reducing',
    });
  }

  function updateReferenceGrid() {
    setVal('.bl-grid-rate-num', fmt.percent(state.interestRate));
    const tbody = document.getElementById('bl-grid-tbody');
    if (!tbody) return;
    tbody.innerHTML = REF_AMOUNTS.map(amt => {
      const isHighRow = amt === state.amount;
      const cells = REF_TENURES.map(t => {
        const monthly = fin.reducingRate(amt, state.interestRate, t).monthlyInstalment;
        const isHighCol = t === state.tenure;
        return `<td class="${isHighCol ? 'highlight-col' : ''}">${fmt.number(monthly, 0)}</td>`;
      }).join('');
      return `<tr class="${isHighRow ? 'highlight' : ''}"><th>RM ${amt.toLocaleString()}</th>${cells}</tr>`;
    }).join('');
  }

  function updateBankCards() {
    const wraps = document.querySelectorAll('.bank-card-wrap');
    const emptyState = document.querySelector('#bank-grid .bank-empty-state');

    const eligible = [];
    const ineligibleReasons = [];
    wraps.forEach((wrap, i) => {
      const bankRate = (+wrap.dataset.rate) / 100;   // quoted reducing rate
      if (!bankRate) { wrap.classList.add('d-none'); return; }

      const minAmt = +wrap.dataset.minAmount || 0;
      const maxAmt = +wrap.dataset.maxAmount || Infinity;
      const minTen = +wrap.dataset.minTenure || 0;
      const maxTen = +wrap.dataset.tenure    || Infinity;

      const reasons = [];
      if (state.amount < minAmt) reasons.push({ code: 'min_loan', params: { min: minAmt } });
      if (state.amount > maxAmt) reasons.push({ code: 'max_loan', params: { max: maxAmt } });
      if (state.tenure < minTen || state.tenure > maxTen) {
        reasons.push({ code: 'tenure_range', params: { min: minTen, max: maxTen } });
      }
      const isEligible = reasons.length === 0;

      wrap.classList.toggle('d-none', !isEligible);
      if (!isEligible) {
        const name = wrap.querySelector('.bank-apply')?.dataset.value || `#${wrap.dataset.bankId}`;
        const rendered = (typeof Calc.eligibility?.renderReasons === 'function')
          ? Calc.eligibility.renderReasons(reasons)
          : reasons.map(r => r.code);
        ineligibleReasons.push(`<strong>${esc(name)}:</strong> ${esc(rendered.join('; '))}`);
        return;
      }

      const r = fin.reducingRate(state.amount, bankRate, state.tenure);

      const rateEl = wrap.querySelector('.bank-rate');
      if (rateEl) rateEl.textContent = fmt.percent(bankRate);
      const tenEl = wrap.querySelector('.bank-tenure');
      if (tenEl) tenEl.textContent = `${state.tenure} year${state.tenure === 1 ? '' : 's'}`;
      const m = wrap.querySelector('.bank-monthly');
      const t = wrap.querySelector('.bank-total');
      if (m) m.textContent = fmt.money(r.monthlyInstalment, 0);
      if (t) t.textContent = fmt.money(r.totalRepayment, 0);

      const apply = wrap.querySelector('.bank-apply');
      const base  = wrap.dataset.applyUrl;
      if (apply && base) {
        try {
          const url = new URL(base);
          url.searchParams.set('amount', state.amount);
          url.searchParams.set('tenure', state.tenure);
          apply.href = url.toString();
        } catch (e) { apply.href = base; }
      }

      eligible.push({
        wrap,
        index: i,
        name: wrap.querySelector('.bank-apply')?.dataset.value || '',
        // Only axes that actually reorder the visible cards (see products.js).
        metrics: { best: r.monthlyInstalment },
      });
    });

    // Best offer = lowest monthly instalment.
    // Badge = best value; order = the user's chosen sort.
    const bestWrap = eligible.length
      ? Calc.products.rank(eligible, 'best', 'asc')[0].wrap
      : null;
    Calc.products.applyOrder(
      wraps,
      Calc.products.rank(eligible, state.sort.key, state.sort.dir),
      bestWrap
    );

    if (emptyState) emptyState.classList.toggle('d-none', eligible.length > 0);

    const note = document.getElementById('bl-ineligible-note');
    const reasonsEl = document.getElementById('bl-ineligible-reasons');
    if (note && reasonsEl) {
      if (ineligibleReasons.length) {
        note.classList.remove('d-none');
        reasonsEl.innerHTML = ineligibleReasons.join('\n');
      } else {
        note.classList.add('d-none');
      }
    }
  }

  function refresh() {
    syncInput('bl-amount-input', state.amount);
    syncInput('bl-rate-input',   (state.interestRate * 100).toFixed(2));
    syncInput('bl-tenure-input', state.tenure);

    updateStatBand();
    updateBankCards();

    if (state.activeTab === 'breakdown') {
      updateBreakdown();
      updateAmortization();
    } else {
      updateReferenceGrid();
    }
  }

  function activateTab(tabId) {
    state.activeTab = tabId;
    document.querySelectorAll('#bl-tabs .btn-tab').forEach(btn => {
      btn.classList.toggle('active', btn.dataset.tab === tabId);
    });
    document.querySelectorAll('.tab-panel').forEach(panel => {
      panel.classList.toggle('d-none', panel.id !== `bl-tab-${tabId}`);
    });
    if (tabId === 'breakdown') { updateBreakdown(); updateAmortization(); }
    else { updateReferenceGrid(); }
  }

  function bindEvents() {
    ['input', 'change'].forEach(evt => document.addEventListener(evt, (e) => {
      const id = e.target.id;
      const v = Calc.input.getValue(e.target);
      if (id === 'bl-amount-input') { state.amount = v || 0;                refresh(); }
      if (id === 'bl-rate-input')   { state.interestRate = (v || 0) / 100;  refresh(); }
      if (id === 'bl-tenure-input') { state.tenure = v || 1;                refresh(); }
    }));

    document.querySelectorAll('#bl-tabs .btn-tab').forEach(btn => {
      btn.addEventListener('click', () => activateTab(btn.dataset.tab));
    });

    const initialSort = Calc.products.bindSort('#bl-sort-select', (sort) => {
      state.sort = sort;
      updateBankCards();
    });
    if (initialSort) state.sort = initialSort;
  }

  document.addEventListener('DOMContentLoaded', () => {
    bindEvents();
    refresh();
  });
})();
